/* Task status and priority — `glossary.md`.
 *
 * In the domain, and `packages/schema` and `packages/contracts` both name it
 * from here rather than declaring their own. These are business vocabulary: a
 * status enum defined in three places is three places that can disagree, and
 * the disagreement would be invisible — one of them would simply accept a value
 * the others refuse.
 *
 * The same move the Event statuses made in STORY-024, for the same reason.
 */
export const TASK_STATUSES = ['open', 'in_progress', 'completed', 'cancelled'];
export const TASK_PRIORITIES = ['low', 'medium', 'high'];
/** What a Task is at, when nobody has said otherwise. Never empty. */
export const DEFAULT_TASK_STATUS = 'open';
/** Finished or called off. Neither is ever overdue, whatever its date. */
export const CLOSED_TASK_STATUSES = [
    'completed',
    'cancelled',
];
//# sourceMappingURL=task-status.js.map